module.exports = __webpack_public_path__ + "img/stockants community.6bbf50fd.png";